import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import InvitationView from "@/pages/InvitationView";
import NotFound from "@/pages/NotFound";

/**
 * Raíz de la SPA.
 *
 * Rutas:
 *  - `/`            → home (índice de mocks para dev/demo)
 *  - `/i/:slug`     → renderizador de invitación pública
 *  - `/404`         → not found explícito (al que `InvitationView` redirige
 *                     cuando una invitación no existe)
 *  - `*`            → cualquier otra ruta cae también en NotFound
 *
 * La navegación funciona con recarga en Cloudflare Pages gracias a
 * `public/_redirects` (`/* /index.html 200`).
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/i/:slug" element={<InvitationView />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
